import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { postData } from '../../../utility/Utility';
import CustomLoader from '../../../Components/CustomLoader/CustomLoader';
import { Button, Modal } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';

const AgentHomeVisitsLead = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('all');
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [newStatus, setNewStatus] = useState('');
    const [feedback, setFeedback] = useState('');
    const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);

    const fetchLeads = async (page = 1) => {
        setLoading(true);
        try {
            const response = await postData('api/agent-leads/all-list', {
                page,
                limit: rowsPerPage,
                status: statusFilter === 'all' ? undefined : statusFilter,
                includeFeedback: true
            });
            if (response?.success) {
                setLeads(response.data || []);
                setTotalPages(response.totalPages || 0);
            } else {
                toast.error(response?.message || 'Failed to fetch leads');
            }
        } catch (error) {
            toast.error('Error fetching leads');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeads(currentPage + 1);
    }, [currentPage, statusFilter]);

    const handleStatusUpdate = async () => {
        if (!selectedLead || !newStatus) return;

        setStatusUpdateLoading(true);
        try {
            const response = await postData(`api/agent-leads/admin/approve`, {
                status: newStatus,
                leadId: selectedLead._id
            });

            if (response?.success) {
                toast.success('Status updated successfully');
                setShowDetailsModal(false);
                setNewStatus('');
                setFeedback('');
                fetchLeads(currentPage + 1);
            } else {
                toast.error(response?.message || 'Failed to update status');
            }
        } catch (error) {
            toast.error('Error updating status');
            console.error('Error:', error);
        } finally {
            setStatusUpdateLoading(false);
        }
    };

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handleViewDetails = (lead) => {
        setSelectedLead(lead);
        setNewStatus(lead.status || 'pending');
        setFeedback('');
        setShowDetailsModal(true);
    };

    const getStatusBadge = (status) => {
        const statusClasses = {
            pending: 'bg-warning',
            approved: 'bg-success',
            rejected: 'bg-danger',
            completed: 'bg-info'
        };
        return (
            <span className={`badge ${statusClasses[status] || 'bg-secondary'}`}>
                {status?.charAt(0).toUpperCase() + status?.slice(1)}
            </span>
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="content-page">

        <CustomLoader loading={loading} />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 py-2">
                            <div className="page-title-box py-2  d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Home Visits Lead Management</h4>
                            </div>

                            <div className="page-title-right">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Home Visits Lead Management
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="card-title mb-0">Agent Home Visits Leads</h5>
                            <div className="d-flex gap-2">
                                <select
                                    className="form-select form-select-sm"
                                    style={{ width: 'auto' }}
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="all">All Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div>

                        <div className="card-body">
                            {loading ? (
                                <CustomLoader />
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Age</th>
                                                <th>Contact</th>
                                                <th>Insurance Type</th>
                                                <th>Plan</th>
                                                <th>Partner</th>
                                                <th>Agent</th>
                                                <th>Status</th>
                                                <th>Created At</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leads.length > 0 ? (
                                                leads.map((lead, index) => (
                                                    <tr key={lead._id}>
                                                        <td>{index + 1 + currentPage * rowsPerPage}</td>
                                                        <td>{lead.name || 'N/A'}</td>
                                                        <td>{lead.age || 'N/A'}</td>
                                                        <td>
                                                            <div>
                                                                <div>
                                                                    <a href={`tel:${lead.phone}`} className="text-decoration-none">
                                                                        {lead.phone}
                                                                    </a>
                                                                </div>
                                                                {lead.whatsapp && (
                                                                    <div>
                                                                        <a
                                                                            href={`https://wa.me/${lead.whatsapp}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="text-decoration-none"
                                                                        >
                                                                            WhatsApp: {lead.whatsapp}
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>{lead.insuranceType || 'N/A'}</td>
                                                        <td>{lead.plan || 'N/A'}</td>
                                                        <td>{lead.partnerId?.name || 'N/A'}</td>
                                                        <td>
                                                            {lead.agentId?.fullName ? (
                                                                <span>{lead.agentId.fullName}</span>
                                                            ) : (
                                                                <span className="text-muted">Unassigned</span>
                                                            )}
                                                        </td>
                                                        <td>{getStatusBadge(lead.status)}</td>
                                                        <td>{formatDate(lead.createdAt)}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => handleViewDetails(lead)}
                                                            >
                                                                View/Update
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="11" className="text-center">
                                                        No leads found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {totalPages > 1 && (
                                <div className="d-flex justify-content-end mt-3">
                                    <ReactPaginate
                                        previousLabel="Previous"
                                        nextLabel="Next"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        pageCount={totalPages}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        forcePage={currentPage}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Details Modal */}
                    <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Lead Details - {selectedLead?.name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedLead && (
                                <div className="row">
                                    <div className="col-md-6">
                                        <h6>Customer Information</h6>
                                        <p><strong>Name:</strong> {selectedLead.name || 'N/A'}</p>
                                        <p><strong>Age:</strong> {selectedLead.age || 'N/A'}</p>
                                        <p><strong>Phone:</strong> <a href={`tel:${selectedLead.phone}`}>{selectedLead.phone}</a></p>
                                        {selectedLead.whatsapp && (
                                            <p>
                                                <strong>WhatsApp:</strong>{' '}
                                                <a
                                                    href={`https://wa.me/${selectedLead.whatsapp}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {selectedLead.whatsapp}
                                                </a>
                                            </p>
                                        )}
                                        <p><strong>Company Name:</strong> {selectedLead.companyName || 'N/A'}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Insurance Details</h6>
                                        <p><strong>Insurance Type:</strong> {selectedLead.insuranceType || 'N/A'}</p>
                                        <p><strong>Plan:</strong> {selectedLead.plan || 'N/A'}</p>
                                        <p><strong>Partner:</strong> {selectedLead.partnerId?.name || 'N/A'}</p>
                                        <p><strong>Current Status:</strong> {getStatusBadge(selectedLead.status)}</p>
                               
                                        {selectedLead.selfie && (
                                            <div className="mt-3">
                                                <h6>Selfie</h6>
                                                <img
                                                    src={selectedLead.selfie}
                                                    alt="Customer selfie"
                                                    className="img-fluid rounded"
                                                    style={{ maxHeight: '200px' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-12 mt-4">
                                        <h6>Agent Information</h6>
                                        {selectedLead.agentId ? (
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <p><strong>Name:</strong> {selectedLead.agentId.fullName || 'N/A'}</p>
                                                </div>
                                                <div className="col-md-4">
                                                    <p><strong>Email:</strong> {selectedLead.agentId.email || 'N/A'}</p>
                                                </div>
                                                <div className="col-md-4">
                                                    <p><strong>Role:</strong> {selectedLead.agentId.role || 'N/A'}</p>
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-muted">No agent assigned</p>
                                        )}
                                    </div>

                                    <div className="col-12 mt-4">
                                        <h6>Feedback & Ratings</h6>
                                        {selectedLead.agentFeedback && (
                                            <div className="mb-3">
                                                <p><strong>Agent Feedback:</strong> {selectedLead.agentFeedback}</p>
                                                {selectedLead.agentGivenRatingUser && (
                                                    <p><strong>Agent Given Rating (User):</strong> {selectedLead.agentGivenRatingUser}/5</p>
                                                )}
                                            </div>
                                        )}
                                        {selectedLead.userFeedback && (
                                            <div className="mb-3">
                                                <p><strong>User Feedback:</strong> {selectedLead.userFeedback}</p>
                                                {selectedLead.userGivenRatingAgent && (
                                                    <p><strong>User Given Rating (Agent):</strong> {selectedLead.userGivenRatingAgent}/5</p>
                                                )}
                                            </div>
                                        )}
                                        {!selectedLead.agentFeedback && !selectedLead.userFeedback && (
                                            <p className="text-muted">No feedback available</p>
                                        )}
                                    </div>

                                    <div className="col-12 mt-4">
                                        <h6>Update Status</h6>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="form-label">New Status</label>
                                                <select
                                                    className="form-select"
                                                    value={newStatus}
                                                    onChange={(e) => setNewStatus(e.target.value)}
                                                >
                                                    <option value="pending">Pending</option>
                                                    <option value="approved">Approved</option>
                                                    <option value="rejected">Rejected</option>
                                                </select>
                                            </div>
                                        
                                        </div>
                                        <div className="mt-3 d-flex gap-2">
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleStatusUpdate}
                                                disabled={!newStatus || statusUpdateLoading}
                                            >
                                                {statusUpdateLoading ? 'Updating...' : 'Update Status'}
                                            </button>
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => setShowDetailsModal(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default AgentHomeVisitsLead;